// Fetches the active token + sale addresses from the backend. The DB is the
// source of truth — addresses are written there when the admin deploys via the
// UI, so we no longer need REACT_APP_*_CONTRACT_ADDRESS in the frontend .env.

import { useEffect, useState, useCallback } from 'react';
import api from '../services/api';

export function useActiveContracts() {
  const [tokenAddress, setTokenAddress] = useState(null);
  const [saleAddress, setSaleAddress] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refetch = useCallback(async () => {
    setLoading(true);
    try {
      const resp = await api.get('/contracts/active');
      setTokenAddress(resp.data?.data?.tokenAddress || null);
      setSaleAddress(resp.data?.data?.saleAddress || null);
      setError(null);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refetch(); }, [refetch]);

  return { tokenAddress, saleAddress, loading, error, refetch };
}
